<template>
  <details
    :display="{ base: 'block', md: 'none' }"
    width="100%"
    v-chakra="{
      '&[open] > summary > svg': {
        transform: 'rotate(90deg)',
      },
      p: {
        color: 'black',
        m: 0,
      },
    }"
  >
    <summary
      mb="sm"
      v-chakra="{
        '&::marker': {
          content: '\'\'',
        },
      }"
    >
      <c-icon name="chevron_right" size="1.1rem" mr="xs" color="brand.purple" />
      <c-heading as="h2" font-size="md" display="inline-block" font-weight="normal" mb="0">
        {{ $t("productReturnV2.details.submitterDetails") }}
      </c-heading>
    </summary>
    <c-text as="span">
      <c-text>{{ contactDetails.fullName }}</c-text>
      <c-text>{{ contactDetails.emailAddress }}</c-text>
      <c-text>{{ contactDetails.phoneNumber }}</c-text>
    </c-text>
    <c-text as="span">
      <c-text>{{ contactDetails.partnerName }}</c-text>
      <c-text>{{ contactDetails.partnerAddress1 }}</c-text>
      <c-text>{{ contactDetails.partnerAddress2 }}</c-text>
      <c-text v-if="contactDetails.partnerAddress3">
        {{ contactDetails.partnerAddress3 }}
      </c-text>
      <c-text>
        {{ contactDetails.partnerZipCode }},
        {{ contactDetails.partnerCity }}
      </c-text>
      <c-text v-if="contactDetails.partnerStateProvinceCode">
        {{
          getProvinceName(contactDetails.partnerCountry, contactDetails.partnerStateProvinceCode)
        }}
      </c-text>
      <c-text>{{ getCountryName(contactDetails.partnerCountry) }}</c-text>
    </c-text>
  </details>
</template>

<script lang="ts">
import { CBox, CHeading, CIcon, CText } from "@chakra-ui/vue";
import { getCountry, getCountrySubdivision } from "@iloq/shared";
import { defineComponent } from "vue";

export default defineComponent({
  name: "SubmitterDetailsMobile",
  components: {
    CBox,
    CText,
    CHeading,
    CIcon,
  },
  props: {
    contactDetails: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getProvinceName: function (countryCode: string, stateProvinceCode: string) {
      return getCountrySubdivision(countryCode, stateProvinceCode);
    },
    getCountryName: function (countryCode: string) {
      return getCountry(countryCode);
    },
  },
});
</script>
